/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';
import { BackendProductVariantRequestDto } from '../../models/backend-product-variant-request-dto';

export interface SalesProductVariantsUpdate$Params {
  /**
   * A unique integer value identifying this product variant.
   */
  id: number;
  body: BackendProductVariantRequestDto;
}

export function salesProductVariantsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesProductVariantsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductVariantDto>;
    }),
  );
}

salesProductVariantsUpdate.PATH = '/api/sales/product_variants/{id}/';
